// images
import projectImg1 from "../images/project/MemoriasDelHablador.jpg";
import projectImg2 from "../images/project/PurpleCircle.jpg";
import projectImg3 from "../images/project/mangle.png";



import projectAvaterImg1 from "../images/blog/blog-avater/logopeq.png";
import projectAvaterImg2 from "../images/blog/blog-avater/logopeq.png";
import projectAvaterImg3 from "../images/blog/blog-avater/logopeq.png";

import projectSingleImg1 from "../images/project/MemoriasDelHablador.jpg";
import projectSingleImg2 from "../images/project/PurpleCircle.jpg";
import projectSingleImg3 from "../images/project/mangle.png";





const proyects = [
    {
        id: '1',
        title: 'Memorias de la Habladorx',
        proyectLink: '/project-menu',
        screens: projectImg1,
        description: 'Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle. Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle.',
        author: 'DigniCO',
        authorTitle:'volunteer',
        bgClass:'projectImg1',
        authorImg:projectAvaterImg1,
        create_at: 'Nov,24',
        projectSingleImg:projectSingleImg1, 
        comment:'',
        blClass:'format-standard-image',
    },
    {
        id: '2',
        title: 'Proyecto Purple Circle',
        screens: projectImg2,
        proyectLink: '/project-single/4',
        description: 'Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle. Texto de los objetivos del proyecto. Aquí debe estar escrito a detalle.',
        author: 'DigniCO',
        authorTitle:'volunteer',
        authorImg:projectAvaterImg2,
        create_at: 'Nov,24',
        projectSingleImg:projectSingleImg2, 
        comment:'',
        blClass:'format-standard-image',
    },
    {
        id: '3',
        title: 'Proyecto Mangle',
        screens: projectImg3,
        proyectLink: '/project-single/5',
        description: 'Programa orientado al fortalecimiento del tejido social en relación con la naturaleza, como base para una transformación hacia una cultura de paz y una justicia ambiental en el Caribe colombiano.',
        author: 'DigniCO',
        authorTitle:'volunteer',
        authorImg:projectAvaterImg3,
        create_at: '2025',
        projectSingleImg:projectSingleImg3, 
        comment:'',
        blClass:'format-standard-image',
    }
];

export default proyects;